var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('course-form',{attrs:{"simplified":false},on:{"cancelEdit":_vm.cancelCreation,"saved":_vm.savedCourse}})}
var staticRenderFns = []

export { render, staticRenderFns }